/**
 * Shared helpers for the mobile admin PWA.
 */
export const API_URL = process.env.REACT_APP_BACKEND_URL;

export const authHeader = () => {
  const password = sessionStorage.getItem('admin_password');
  return password ? { Authorization: `Basic ${btoa(':' + password)}` } : {};
};

export const apiGet = async (path) => {
  const res = await fetch(`${API_URL}${path}`, { headers: authHeader() });
  if (!res.ok) throw new Error(`${res.status} ${res.statusText}`);
  return res.json();
};

export const apiPost = async (path, body) => {
  const res = await fetch(`${API_URL}${path}`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...authHeader() },
    body: JSON.stringify(body),
  });
  if (!res.ok) {
    const err = await res.json().catch(() => ({}));
    throw new Error(err.detail || `${res.status}`);
  }
  return res.json();
};

export const apiPatch = async (path, body) => {
  const res = await fetch(`${API_URL}${path}`, {
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...authHeader() },
    body: JSON.stringify(body),
  });
  if (!res.ok) {
    const err = await res.json().catch(() => ({}));
    throw new Error(err.detail || `${res.status}`);
  }
  return res.json();
};

export const isAuthed = () => !!sessionStorage.getItem('admin_password');
